module.exports = __webpack_public_path__ + "img/placeholder_lote_hotel_contrate_blue_diamond.d52e792e.jpg";